import React, { memo } from 'react';
import Avatar from '@material-ui/core/Avatar';
import { buildAvatarName } from '../../../shared/helpers/buildAvatarName';
import styles from './profileCard.module.scss';

export default memo(function ProfileCard() {
    return (
        <>
            <div className={styles.triangle} />
            <div className={styles.triangleBorder} />
            <div className={styles.bubleAvatar}>
                <Avatar className={styles.avatar}>{buildAvatarName('Matias Nicolas Ortigoza')}</Avatar>
            </div>
        </>
    );
});
